import styled from '@emotion/styled'

export const FormWrapper = styled.form``
